import React from 'react';
import { Palette } from 'lucide-react';
import { clienteColorAuto } from '../../utils/clienteColor';

// Tinte ben distinguibili tra loro sul bordo delle card del calendario.
const PRESET = ['#2563eb', '#16a34a', '#dc2626', '#d97706', '#7c3aed', '#db2777', '#0891b2', '#65a30d', '#475569', '#9a3412'];

interface Props {
    // '#rrggbb' = colore scelto; '' o undefined = automatico.
    value?: string | null;
    onChange: (value: string) => void;
    // Id del cliente, per mostrare l'anteprima del colore automatico (assente in creazione).
    clienteId?: number | null;
    disabled?: boolean;
}

/** Scelta del colore del cliente nel calendario: automatico (dall'id) o scelto a mano. */
export const ColoreCalendarioField: React.FC<Props> = ({ value, onChange, clienteId, disabled }) => {
    const manuale = !!value;
    const auto = clienteColorAuto(clienteId);
    return (
        <div className="space-y-2">
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Palette size={16} className="text-gray-500" /> Colore nel calendario
            </label>
            <div className="flex flex-wrap items-center gap-2">
                <button type="button" disabled={disabled} onClick={() => onChange('')}
                        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border text-sm ${!manuale ? 'border-blue-500 bg-blue-50 text-blue-800 font-semibold' : 'border-gray-200 text-gray-600 hover:bg-gray-50'} disabled:opacity-60`}>
                    <span className="w-4 h-4 rounded-full border border-black/10"
                          style={{ background: auto || 'conic-gradient(#ef4444, #f59e0b, #22c55e, #3b82f6, #a855f7, #ef4444)' }} />
                    Automatico
                </button>
                {PRESET.map(c => (
                    <button key={c} type="button" disabled={disabled} onClick={() => onChange(c)} title={c}
                            className={`w-7 h-7 rounded-full border-2 ${value === c ? 'border-gray-900 scale-110' : 'border-white shadow'} disabled:opacity-60`}
                            style={{ background: c }} />
                ))}
                <label className={`flex items-center gap-1 text-xs text-gray-600 ${disabled ? 'opacity-60' : 'cursor-pointer'}`} title="Altro colore">
                    <input type="color" disabled={disabled} value={value || '#2563eb'}
                           onChange={e => onChange(e.target.value.toLowerCase())}
                           className="w-7 h-7 p-0 border-0 bg-transparent cursor-pointer" />
                    Altro
                </label>
            </div>
            <p className="text-xs text-gray-500">
                {manuale ? 'Bordo delle card di mandati e turni di questo cliente.' : 'Colore calcolato automaticamente, sempre lo stesso per questo cliente.'}
            </p>
        </div>
    );
};
